import React from 'react'
import { PrismicRichText, PrismicLink } from '@prismicio/react'

const Text = ({ slice }) => {
  return (
    <section className='component-text mx-auto max-w-screen-xl p-6'>
      <div className={`${slice.primary.two_column === true ? 'columns ' : ''}prose prose-lg max-w-full`}>
        <PrismicRichText field={slice.primary.text.richText} />
        {slice.primary.button_link?.url && slice.primary.button_text && (
          <PrismicLink className='button rounded' href={slice.primary.button_link.url}>
            {slice.primary.button_text}
          </PrismicLink>
        )}
      </div>
    </section>
  )
}

export default Text
